import { useCallback } from 'react';
import { useToggler } from '@cbhq/cds-common/hooks/useToggler';
import { IconButton } from '@cbhq/cds-web/buttons';
import { Box } from '@cbhq/cds-web/layout';

import { Thread } from './Thread';

const floatingButtonStyles: React.CSSProperties = {
  position: 'fixed',
  bottom: '24px',
  right: '24px',
  zIndex: 1000,
};

const chatPanelStyles: React.CSSProperties = {
  position: 'fixed',
  bottom: '24px',
  right: '24px',
  width: '600px',
  height: '70vh',
  maxHeight: '700px',
  zIndex: 999,
  borderRadius: '16px',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08)',
  overflow: 'hidden',
  border: '1px solid var(--line, #e0e0e0)',
};

const maximizedPanelStyles: React.CSSProperties = {
  position: 'fixed',
  bottom: '24px',
  right: '24px',
  width: '900px',
  height: '90vh',
  maxHeight: '1100px',
  zIndex: 9999,
  borderRadius: '16px',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08)',
  overflow: 'hidden',
  border: '1px solid var(--line, #e0e0e0)',
};

export function AIChatWidget() {
  const [chatPanelIsOpen, { toggle: toggleChatPanel, toggleOff: closeChatPanel }] =
    useToggler(false);
  const [isMaximized, { toggle: toggleMaximized, toggleOff: minimize }] = useToggler(false);

  const handleClose = useCallback(() => {
    minimize();
    closeChatPanel();
  }, [minimize, closeChatPanel]);

  return (
    <>
      {chatPanelIsOpen && (
        <Box style={isMaximized ? maximizedPanelStyles : chatPanelStyles}>
          <Thread
            onClose={handleClose}
            isMaximized={isMaximized}
            onToggleMaximize={toggleMaximized}
          />
        </Box>
      )}

      {!chatPanelIsOpen && (
        <Box style={floatingButtonStyles}>
          <IconButton
            active
            name="support"
            accessibilityLabel="Open AI Chat"
            variant="primary"
            compact={false}
            onClick={toggleChatPanel}
          />
        </Box>
      )}
    </>
  );
}
